var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-map',{attrs:{"data":_vm.data,"num":4,"text":"新增"}})
}
var staticRenderFns = []

export { render, staticRenderFns }